import React, {useState} from 'react';
import Collapse from "@kunukn/react-collapse";
import { Link } from 'react-router-dom'

import './accordion.css'

// @ts-ignore
function Accordion({heading}) {
    const [isOpen, setIsOpen] = useState(false)

    return (
        <div key={Object.keys(heading)[0]}>
            <button className='cursor-pointer accordion__heading text-4xl my-8' onClick={() => setIsOpen(!isOpen)}>
                {Object.keys(heading)[0]}
            </button>

            <Collapse isOpen={isOpen}>
                {
                    // @ts-ignore
                    heading[Object.keys(heading)[0]].map(chapter => (
                        <Link key={Object.keys(chapter)[0]}
                           to={`/comics/circle-lan/${Object.keys(heading)[0]}/${Object.keys(chapter)[0]}`}
                           className={'w-full flex justify-center accordion__content'}
                        >
                            <p>{Object.keys(chapter)[0]}</p>
                        </Link>
                    ))
                }
            </Collapse>

            <div className={'w-full flex justify-center'}>
                <hr className={'line'}/>
            </div>
        </div>
    );
}

export default Accordion;